import { variants } from "@/components/ui/Badge/utils";

import { TripStage } from "@/features/trips/types";

export const TRIP_STAGE_BADGE_VARIANTS: Record<
  keyof typeof TripStage,
  keyof typeof variants
> = {
  NOT_STARTED: "gray",
  PENDING_DEPARTURE: "yellow",
  IN_TRANSIT: "teal",
  PENDING_ARRIVAL: "yellow",
  COMPLETED: "green",
  CANCELED: "red",
};

// 20 minutes in seconds
export const MIN_DWELL_DURATION_SECONDS = 20 * 60;

export const MIN_DWELL_DURATION_MS = 1000 * MIN_DWELL_DURATION_SECONDS;

export enum LocationSource {
  LocationSourceUnspecified = "LOCATION_SOURCE_UNSPECIFIED",
  GPS = "GPS",
  Derived = "DERIVED",
  Fixed = "FIXED",
  Cell = "CELL",
}
